var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimizeButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#FC5726",
    strokeWidth: 2,
    fill: "#FFF",
    x: 1,
    y: 1,
    width: 38,
    height: 37,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.797 9.19v8.776l.001.02c.001.035.002.068.005.102l.008.057.01.062c.004.021.01.041.015.062l.015.056c.005.02.013.039.02.057l.02.058.024.05a1.25 1.25 0 0 0 .056.105c.011.02.022.04.035.058.01.016.023.032.035.047l.037.05c.021.026.043.05.066.074l.015.016.017.015c.024.023.048.046.074.067l.05.037c.015.012.03.024.047.035.018.013.038.024.058.035a1.25 1.25 0 0 0 .105.055c.017.009.033.017.05.024.019.008.038.014.058.021.018.007.038.015.057.02l.056.015.062.014c.02.005.04.007.062.01l.057.009c.034.003.067.004.1.005h8.798a1.237 1.237 0 0 0 0-2.473h-5.79l9.618-9.618a1.236 1.236 0 1 0-1.75-1.749L23.27 14.98V9.19a1.234 1.234 0 0 0-1.236-1.237c-.683 0-1.237.554-1.237 1.237m-1.594 21.62v-8.776l-.001-.02c-.001-.035-.002-.068-.005-.102-.002-.02-.006-.038-.009-.057-.003-.021-.005-.042-.01-.062-.003-.021-.009-.041-.014-.062a.924.924 0 0 0-.015-.056c-.005-.02-.013-.039-.02-.057l-.02-.058-.025-.05a1.25 1.25 0 0 0-.028-.06l-.027-.045c-.011-.02-.022-.04-.035-.058a1.323 1.323 0 0 0-.035-.047l-.037-.05a1.49 1.49 0 0 0-.067-.074l-.015-.016-.016-.015a1.49 1.49 0 0 0-.074-.067l-.05-.037a1.323 1.323 0 0 0-.047-.035c-.019-.013-.039-.024-.058-.035a1.25 1.25 0 0 0-.105-.055c-.017-.009-.033-.017-.05-.024l-.058-.021c-.018-.007-.038-.015-.057-.02l-.056-.015-.062-.014c-.02-.005-.04-.007-.062-.01l-.057-.009a1.367 1.367 0 0 0-.101-.005H9.19a1.237 1.237 0 0 0 0 2.473h5.79L5.362 32.89a1.236 1.236 0 1 0 1.75 1.749l9.617-9.618v5.79a1.234 1.234 0 0 0 1.237 1.237c.683 0 1.237-.554 1.237-1.237",
    fill: "#FC5726"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizeButton);
export default __webpack_public_path__ + "static/media/minimize_button.ddb9de029b0de43d3640df773e41dc3a.svg";
export { ForwardRef as ReactComponent };